<script setup lang="ts">
import { ref } from 'vue'
import { useDisplay } from 'vuetify'
import FolderTree from '../FolderTree.vue'
import type { FolderItem } from '@/modules/documents-new/types/folder.types'
import CustomCloseButton from '@/components/createdUi/CustomCloseButton.vue'

interface Props {
  folders: FolderItem[]
  selectedFolderId?: string | null
}

interface Emits {
  (e: 'select', folderId: string | null, folderName: string): void
}

defineProps<Props>()
const emit = defineEmits<Emits>()

const { smAndDown } = useDisplay()
const isOpen = ref(false)

const open = () => {
  isOpen.value = true
}

const close = () => {
  setTimeout(() => {
    isOpen.value = false
  }, 0)
}

const handleSelect = (folderId: string | null, folderName: string) => {
  emit('select', folderId, folderName)
  close()
}

defineExpose({ open, close })
</script>

<template>
  <VDialog
    v-model="isOpen"
    :max-width="smAndDown ? '100%' : 500"
    :fullscreen="smAndDown"
  >
    <VCard :class="smAndDown ? 'pa-4' : 'pa-6'">
      <div class="d-flex justify-space-between align-center mb-6">
        <span class="text-h4">Выберите папку</span>
        <CustomCloseButton :close-action="close" />
      </div>

      <div style="max-height: 500px; overflow-y: auto;">
        <FolderTree
          :folders="folders"
          :selected-folder-id="selectedFolderId"
          :select-on-arrow="false"
          @select="handleSelect"
        />
      </div>
    </VCard>
  </VDialog>
</template>

<style scoped lang="scss">
:deep(.v-card) {
  border-radius: 12px;
}
</style>
